import { styled } from '@mui/material'

import { theme } from 'styles/theme'

export const ContainerIcon = styled('div')(() => ({
  width: '35px',
  height: '35px',
  background: '#F8F8F8',
  borderRadius: '8px',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

export const Separator = styled('div')(() => ({
  width: '1fr',
  flexGrow: '1',
  borderTop: '0.5px dashed #CBCBCB',
  alignSelf: 'center',
  marginTop: '2px'
}))

export const DetailContent = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column'
}))

export const DetailWrapper = styled('div')(() => ({
  marginTop: 12,
  padding: 12,
  border: '1px solid #EDEBEB',
  borderRadius: '5px',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  WebkitFlexWrap: 'nowrap'
}))

export const Link = styled('a')(() => ({
  margin: 0,
  padding: 0,
  fontWeight: 600,
  color: '#231F20',
  cursor: 'pointer'
}))

export const AccordionWrapper = styled('div')(() => ({
  marginTop: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: 'calc(40vh + 12px)',
  [theme.breakpoints.up(450)]: {
    width: 'auto'
  }
}))

export const RecurrenceContent = styled('div')(() => ({
  marginTop: 12,
  padding: 12,
  border: '1px solid #EDEBEB',
  borderRadius: '5px',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  gap: 12
}))
